"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookiePopupWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// we lazy load the CookiePopup as it can take 0.2 seconds to interactive
const dynamic_1 = __importDefault(require("next/dynamic"));
const CookiePopupWrapper_module_css_1 = __importDefault(require("./CookiePopupWrapper.module.css"));
const CookiePopup = (0, dynamic_1.default)(async () => 
// https://nextjs.org/docs/advanced-features/dynamic-import#with-named-exports
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-return
Promise.resolve().then(() => __importStar(require("@snapchat/sc-web-frame"))).then((module) => module.CookiePopup));
/**
 * A wrapper around the cookie popup from web-common. It skips rendering if the isDev flag is set.
 */
function CookiePopupWrapper({ locale, GAID, isDev, cookieSettingsUrl, cookieDomain, }) {
    // when running on dev, the sc-accepted-cookies cookie isn't read or set,
    // causing the notice to always render, even if you accept the notice.
    // therefore, just skip rendering it if running in dev
    if (!isDev) {
        return (
        // when theming is applied, this causes the text to be overwritten - the cookie
        // notice is always light, so make sure that text color is explicitly set to black
        (0, jsx_runtime_1.jsx)("span", { className: CookiePopupWrapper_module_css_1.default.cookieWrapper, children: (0, jsx_runtime_1.jsx)(CookiePopup, { GAID: GAID, cookieSettingsUrl: cookieSettingsUrl, locale: locale, cookieDomain: cookieDomain }) }));
    }
    else {
        return null;
    }
}
exports.CookiePopupWrapper = CookiePopupWrapper;
//# sourceMappingURL=CookiePopupWrapper.js.map